import styled from "styled-components"
import { Colors } from "styles/app-styles"
import DataTable_s from "components/table/data-table-styles"
import { CarouselContent_s, SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"

export const RentRoll_s = styled.div`
  .p-paginator {
    bottom: 30px;
  }
`

export const RentRollTable_s = styled(DataTable_s)`
  border-spacing: 15px;

  .p-datatable-thead > tr {
    height: 30px;
  }


  .p-datatable-thead > tr > th {
    padding: 0px 0px !important;
    &:first-child {
      padding: 5px 5px 5px 15px !important;
    }
    &.p-selection-column {
      padding: 0px 5px !important;
    }
      input::placeholder {
      color: ${Colors.darkDenim};
    }
  }

  .p-datatable-scrollable-view.p-datatable-frozen-view .p-datatable-scrollable-header-table {
    width: 160px;
  }

  .p-datatable-frozen-view .p-datatable-scrollable-header .p-datatable-thead th {
    height: 30px;
    vertical-align: bottom;
    td {
      height: 30px;
    }
  }

  ${CarouselContent_s}{
    > div {
      margin-top: 0;
    }
  }

  // footer
  .selection-count {
    bottom: 86px;
    font-size: smaller;
    left: 5px;
    position: absolute;
    z-index: 999;
  }
`

export const RentBasic_s = styled.div`
  width: 585px;
  ${SingleRowCarouselState_s}{
    display: grid;
    grid-template-columns: 75px 150px 185px 185px;
    grid-template-rows: auto;
    > div > label { line-height: 30px; }
  }
`
